/**
 * Produkt pro ověření očima: fotka, kód, název a odkaz do e-shopu.
 * Používá se u dvojice originál ↔ 2. jakost, ať je hned vidět, že sedí.
 */
export function ProduktKarticka({
  label,
  code,
  name,
  image,
  url,
}: {
  label: string;
  code: string;
  name: string;
  image?: string;
  url?: string;
}) {
  return (
    <div className="flex gap-3 min-w-0">
      {image ? (
        <img
          src={image}
          alt=""
          loading="lazy"
          className="w-16 h-16 rounded-lg object-contain border border-border bg-bg shrink-0"
        />
      ) : (
        <div className="w-16 h-16 rounded-lg border border-border bg-bg shrink-0" />
      )}
      <div className="min-w-0 text-sm">
        <div className="text-xs uppercase tracking-wider text-text-muted">{label}</div>
        <div className="font-mono font-semibold text-text">{code}</div>
        <div className="text-text-secondary">{name || '—'}</div>
        {url && (
          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            className="text-xs text-primary underline hover:text-text"
          >
            Otevřít v e-shopu ↗
          </a>
        )}
      </div>
    </div>
  );
}
